export default [
  {
    name: 'dataMonitor',
    path: '/dataMonitor/index',
    meta: { title: '数据监控' },
    component: () =>
      import(
        /* webpackChunkName: "miniappRegister" */ '../../pages/sinsam/dataMonitor'
      )
  },
  {
    name: 'dataMonitorChart',
    path: '/dataMonitor/chart',
    meta: { title: '数据监控' },
    component: () =>
      import(
        /* webpackChunkName: "miniappRegister" */ '../../pages/sinsam/monitorChart'
      )
  }
]
